export const server_url = "https://enatega.com/"
export const cloudinary_upload_url = "https://api.cloudinary.com/v1_1/dgdpsy6t9/image/upload"
export const cloudinary_category = "s84tnnnr"
export const cloudinary_food = "ra6jix5g"
export const cloudinary_profile = "nh9fd8i5"